var map = {
	"./banana_tree/UK/manifest.json": [
		1620,
		1620
	],
	"./breakfast_club/UK/manifest.json": [
		8326,
		8326
	],
	"./brother_marcus/UK/manifest.json": [
		3634,
		3634
	],
	"./brother_marcus_south_ken/UK/manifest.json": [
		5105,
		5105
	],
	"./honest_burger/UK/manifest.json": [
		6583,
		6583
	],
	"./kricket/UK/manifest.json": [
		9801,
		9801
	],
	"./moto/UK/manifest.json": [
		833,
		833
	],
	"./sushi_dog/UK/manifest.json": [
		5273,
		5273
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3293;
module.exports = webpackAsyncContext;